import i18nDataEN from './i18nData-en';

export default {
    en : i18nDataEN,
    de : i18nDataEN,
    fr : i18nDataEN,
    pt : i18nDataEN
}